import React from 'react';

/**
 * Layout primitive for labelled form controls.
 * Use with TextInput, SelectInput, TextareaInput, or domain widgets.
 */
export default function FormField({
    label,
    htmlFor,
    required = false,
    error,
    helper,
    note,
    className = '',
    children,
}) {
    return (
        <div className={className}>
            {label ? (
                <label htmlFor={htmlFor} className="form-label">
                    {label}
                    {required ? <span className="text-red-500"> *</span> : null}
                </label>
            ) : null}
            {children}
            {error ? <p className="form-error">{error}</p> : null}
            {(helper || note) && !error ? (
                <p className={note ? 'field-note' : 'form-helper'}>{helper || note}</p>
            ) : null}
        </div>
    );
}
